import { AppBar } from '@mui/material'
import { Box, Toolbar, Stack, useEnvironmentBackgroundColor, useIsMobileVariant } from '@dhl-ui/components'
import { usePage } from '../../context'
import { type PageHeaderProps } from './types'
import { HeaderLayoutProvider } from './context/HeaderLayout'
import { HeaderLogo } from './HeaderLogo'
import { HeaderMenu } from './HeaderMenu'

/**
 * Header for Page and PageWithRefresh
 */
export const Header = ({ environment = 'prod', onClick, endNode, startNode, logo }: PageHeaderProps) => {
  const isMobile = useIsMobileVariant()
  const { hasSideMenu, noPrintHeader } = usePage()
  const color = useEnvironmentBackgroundColor(environment)
  const showMenu = hasSideMenu && isMobile

  return (
    <AppBar
      color="secondary"
      sx={{
        color: color.color,
        backgroundColor: color.bgColor,
        backgroundImage: 'none',
        boxShadow: 'none',
        displayPrint: noPrintHeader ? 'none' : 'inherit',
        overflow: 'hidden',
      }}
    >
      <Toolbar data-testid="page-header" environment={environment} isNotTransparent>
        <Stack direction="row" gap={1.25}>
          {showMenu ? <HeaderMenu /> : null}
          <HeaderLogo logo={logo} onClick={onClick} fill={color.fill} />
        </Stack>
        {startNode}
        {endNode ? (
          <HeaderLayoutProvider>
            <Box
              sx={{
                display: 'flex',
                displayPrint: 'none',
                alignItems: 'center',
                ml: 'auto',
              }}
            >
              {endNode}
            </Box>
          </HeaderLayoutProvider>
        ) : null}
      </Toolbar>
    </AppBar>
  )
}
